import React from "react";
import {Divider, Popover, Typography} from "@material-ui/core";
import Paper from "../../lib/appfuse-react/component/Paper";
import i18n from "../../lib/appfuse-react/core/i18n";
import Box from "../../lib/appfuse-react/component/Box";
import RichText from "../../lib/appfuse-react/component/RichText";
import Expander from "../../lib/appfuse-react/component/Expander";
import Button from "../../lib/appfuse-react/component/Button";
import CloseIcon from "@material-ui/icons/Close";
import lang from "../../lib/appfuse-react/core/lang";
import {isEmptyRichText} from "../../layout/Desktop";

function LatestNews(props) {
    const {open, anchorEl, data} = props;

    return (
        <Popover open={open}
                 onClose={props.onClose}
                 anchorEl={anchorEl.current}
                 anchorOrigin={{
                     vertical: 'bottom',
                     horizontal: 'center',
                 }}
                 transformOrigin={{
                     vertical: 'top',
                     horizontal: 'left',
                 }}>
            <Paper overflow='auto' padding={1.5}>
                <Box display={'flex'} paddingTop={1} paddingX={3} paddingBottom={1} justifyContent={'center'} alignItems={'center'}>
                    <Typography variant='h6' noWrap>{i18n.translate('Latest News')}</Typography>
                    <Expander/>
                    <Button icon={<CloseIcon/>} variant='icon' onClick={props.onClose}/>
                </Box>
                <Divider/>
                <Box paddingX={3} paddingY={2}>
                    { (lang.isNotEmpty(data) && lang.isNotNullOrUndefined(data) && !isEmptyRichText(data)) ?
                        <RichText name='latestNews' value={data}/>
                        : <Typography variant='body1'>{i18n.translate('No news')}</Typography>

                    }
                </Box>
            </Paper>
        </Popover>
    );
}

export default LatestNews;